import type { DatabaseInfo } from '@/types';

/**
 * Resolve whether a database should appear in the sidebar tree, given the
 * user's visibility overrides. Default behavior:
 *   • the default DB (the one named in the connection config) → visible
 *   • every other DB (including non-system ones) → hidden
 *
 * This matches the "I configured one database, show me that one" expectation.
 * Users pin extra databases by checking them on the Connection info tab —
 * their choices go into `app-store.databaseVisibility` and win over the
 * default rule here.
 */
export function isDatabaseVisible(
  db: DatabaseInfo,
  overrides: Record<string, boolean> | undefined,
): boolean {
  const explicit = overrides?.[db.name];
  if (typeof explicit === 'boolean') return explicit;
  return db.isDefault === true;
}
